export default "__VITE_ASSET__CXXJlLvp__"